export default __webpack_public_path__ + "static/media/tiffanie_hilson.76956445.jpeg";